import { Fancybox } from '@fancyapps/ui';

export function fancyBox() {

    Fancybox.bind('[data-fancybox="gallery"]', {
        //
    });
}